import React, {useState, useEffect} from 'react';
import { Row, Col, } from 'react-bootstrap';
import ApplicationCard from './ApplicationCard';
import SchemeCard from './SchemeCard';
import scheme_image from "./../../../images/schemes/scheme.png";
import "./Scheme.css";
import { getAllSchemesList, getUserSchemeStats } from "../../../services/schemeApiService/SchemeApiService";
import ApplicationsTable from './ApplicationsTable';

function SchemesPage({onApply, onClickDetails, changeActiveScheme}) {

  const[activeTab,setActiveTab]= useState(localStorage.getItem("activeTab")?localStorage.getItem("activeTab"):"schemes");
  const [schemes, setSchemes] = useState([
    // {
    //   id: 1,
    //   title: "Application For Devbhoomi Uttrakhand Dronacharya Award",
    //   category: "Ongoing",
    //   date: "20/06/2025",
    // },
    // {
    //     id: 2,
    //     title: "Application For Devbhoomi Uttrakhand Dronacharya Award",
    //     category: "Closed",
    //     date: "20/06/2025",
    // },
    // {
    //     id: 3,
    //     title: "Application For Devbhoomi Uttrakhand Dronacharya Award",
    //     category: "Upcoming",
    //     date: "20/06/2025",
    // }
  ]);

  const [schemeStats, setSchemeStats] = useState({
    "total": {
        "current": 0,
        "lastMonth": 0,
        "difference": 0
    },
    "approved": {
        "current": 0,
        "lastMonth": 0,
        "difference": 0
    },
    "rejected": {
        "current": 0,
        "lastMonth": 0,
        "difference": 0
    },
    "pending": {
        "current": 0,
        "lastMonth": 0,
        "difference": 0
    }
  });

  const fetchSchemes = async () => {
        try {
          const response = await getAllSchemesList();

          const transformedData = response.data.data.map(item => {
            const today = new Date();
            const startDate = new Date(item.start_date);
            const endDate = new Date(item.end_date);

            let category = '';
            let displayDate;

            if (startDate > today) {
              category = 'Upcoming';
              displayDate = startDate;
            } else if (endDate < today) {
              category = 'Closed';
              displayDate = endDate;
            } else {
              category = 'Ongoing';
              displayDate = endDate;
            }

            // const formatDate = (date) => {
            //   const day = String(date.getDate()).padStart(2, '0');
            //   const month = String(date.getMonth() + 1).padStart(2, '0');
            //   const year = date.getFullYear();
            //   return `${day}/${month}/${year}`;
            // };

            const formatDate = (date) => {
              const day = String(date.getUTCDate()).padStart(2, '0');
              const month = String(date.getUTCMonth() + 1).padStart(2, '0');
              const year = date.getUTCFullYear();
              return `${day}/${month}/${year}`;
            };

            return {
              id: item.id,
              title: item.scheme_name,
              category: category,
              date: formatDate(displayDate),
              description: item.scheme_description
            };
          });

          const categoryOrder = {
            'Ongoing': 0,
            'Upcoming': 1,
            'Closed': 2
          };
      
          const sortedData = transformedData.sort((a, b) => {
            return categoryOrder[a.category] - categoryOrder[b.category];
          });

          setSchemes(sortedData);
  
        } catch (error) {
          console.error("Error fetching schemes:", error);
        }
  };

  const fetchStats = async () => {
    try {
      const response = await getUserSchemeStats();
      setSchemeStats(response.data.data);
      // console.log(response.data.data);
    } catch (error) {
      console.error("Error fetching schemes:", error);
    }
  };

  useEffect(() => {
    fetchSchemes();
    fetchStats();
  }, []);

  
  return (
    <div className='scheme-widgets-container user-schemes-container'>
        <div className="header-container">
        <h4 className="card-title">Grant Schemes & Scholarship</h4>
        <div class="tab-container">
          <button class={`tab ${activeTab==="schemes"?"active":"inactive"}`} onClick={()=>{setActiveTab("schemes"); localStorage.setItem("activeTab", "schemes");}}>Total Schemes</button>
          <button class={`tab ${activeTab==="applications"?"active":"inactive"}`} onClick={()=>{setActiveTab("applications"); localStorage.setItem("activeTab", "applications");}}>My Applications</button>
        </div>
        </div>
        <div className='application-card-container'>
          {/* <ApplicationCard type="Total Applications" count={schemeStats.total.current} updatedcount={schemeStats.total.difference}/> */}
          <ApplicationCard type="approved" count={schemeStats?.approved?.count} updatedcount={schemeStats?.approved?.lastMonth}/>
          <ApplicationCard type="pending" count={schemeStats?.pending?.count} updatedcount={schemeStats?.pending?.lastMonth}/>
          <ApplicationCard type="clarification" count={schemeStats?.clarification?.count} updatedcount={schemeStats?.clarification?.lastMonth}/>
          {/* <ApplicationCard type="incomplete" count="04" updatedcount="5"/> */}
          <ApplicationCard type="rejected" count={schemeStats?.rejected?.count} updatedcount={schemeStats?.rejected?.lastMonth}/>
          
        </div>
        <h4 className="card-title">Grant Schemes & Scholarship</h4>
        {activeTab==="schemes" && (
          <div className='available-schemes-container Scheme-container'>
                  <Row>
                      {schemes.map(scheme => (
                        <Col key={scheme.id} xs={12} sm={6} md={4} lg={3} className="mb-4">
                          <SchemeCard id={scheme.id} scheme={scheme_image} category={scheme.category} title={scheme.title} date={scheme.date} onClickApply={()=>{onApply(scheme.id)}} onClickDetails={()=>{onClickDetails(scheme.id, scheme.category, scheme); changeActiveScheme(scheme);}} />
                        </Col>
                      ))}
                  </Row>
          </div>
        )}
        {activeTab==="applications" && (
          <div className='applications-container '>
            <ApplicationsTable/>
          </div>
        )}
    </div>
  )
}

export default SchemesPage;